import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { getProsegUrls, scrollToProsegSection } from "./ProsegNav";
import { ProsegHero } from "./ProsegHero";
import {
  ProsegApp,
  ProsegBusiness,
  ProsegCard,
  ProsegFaq,
  ProsegPix,
  ProsegSecurity,
  ProsegValues,
} from "./ProsegSections";
import { useMotionLevel, useReveal } from "./prosegMotion";
import "./proseg.css";

/**
 * Landing "/" da PROSEG PAY — port do design "PROSEG PAY - Landing.dc.html".
 * O topo (ProsegNav) e o rodapé (ProsegFooter) são montados em App.jsx.
 */
const ProsegLanding = () => {
  const location = useLocation();
  const pageRef = useRef(null);
  const motion = useMotionLevel();
  const urls = getProsegUrls();

  useReveal(pageRef);

  // Navegação por hash (/#pix etc.) vinda de outras rotas ou de link direto.
  useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.replace(/^#/, "");
    if (!id) return undefined;
    const timer = window.setTimeout(() => scrollToProsegSection(id), 120);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <main
      ref={pageRef}
      className="pp-page"
      style={{ "--play": motion ? "running" : "paused" }}
    >
      <ProsegHero urls={urls} motion={motion} />
      <ProsegValues />
      <ProsegCard motion={motion} />
      <ProsegPix />
      <ProsegSecurity />
      <ProsegBusiness urls={urls} />
      <ProsegFaq />
      <ProsegApp urls={urls} motion={motion} />
    </main>
  );
};

export default ProsegLanding;
